export class Converter {

    constructor ( target = '.js-converter', options = {} ) {
        this.target = target;

        this.type = 'celsius'

        this.options = {
            ...options
        }
    }

    init () {
        this.$container = document.querySelector(this.target);

        this.$toggles = this.$container.querySelectorAll('.js-converter__toggle');

        this.$toggles.forEach( $toggle => {
            $toggle.addEventListener('click', () => {
                this.convert($toggle.dataset.type);

                this.$toggles.forEach( $toggle => {
                    $toggle.classList.remove('c-toggle-buttons__button--active');
                });

                $toggle.classList.add('c-toggle-buttons__button--active');
            })
        })
    }

    convert(type) {
        if(this.type === type) {
            return
        }

        this.type = type;

        this.convertItems();
    }

    convertItems() {

        const $conversions = document.querySelectorAll('[data-temp]');
        $conversions.forEach($conversion => {
            const increment = ($conversion.dataset.round ? parseInt($conversion.dataset.round) : 1);

            $conversion.innerText = this.calculate($conversion.dataset.temp, increment);
        });

        const $files = document.querySelectorAll(`[data-sheet-${this.type}]`);
        const fileType = `sheet${this.type[0].toUpperCase() + this.type.slice(1)}`;
        $files.forEach($file => {
            if($file.dataset[fileType] !== '' || $file.dataset[fileType] != false) {
                $file.href = $file.dataset[ fileType ];
            }
        });

        const $types = document.querySelectorAll('[data-temp-type]');
        $types.forEach($type => {
            $type.innerText = this.type.charAt(0).toUpperCase();
        });

        const $labels = document.querySelectorAll('[data-label]');
        $labels.forEach($label => {
            if($label.dataset.hasOwnProperty('labelCelsius') && $label.dataset.hasOwnProperty('labelFahrenheit')) {
                if(this.type == 'celsius') {
                    $label.dataset.label = $label.dataset.labelCelsius;
                } else {
                    $label.dataset.label = $label.dataset.labelFahrenheit;
                }
            }
        });
    }

    round(value, increment = 1) {
        return Math.round(value / increment) * increment;
    }

    calculate(temp, increment) {
        if(this.type === 'fahrenheit') {
            return this.round(((temp * 1.8) + 32), increment);
        } else {
            return temp;
        }
    }

}
